const PLACEHOLDER = "/static/images/default-property-image.png";

export default function StudioCard({ studio }) {
  const { name, size_sqft, available_from, hero_image_url, price_poa } = studio;

  return (
    <div className="flex flex-col">
      <div className="relative aspect-square bg-gray-100 overflow-hidden">
        {price_poa && (
          <div className="absolute top-0 left-0 right-0 bg-gray-500/80 text-white text-sm font-semibold tracking-widest uppercase text-center py-1.5 z-10">
            POA
          </div>
        )}
        <img
          src={hero_image_url || PLACEHOLDER}
          alt={name}
          className="w-full h-full object-cover"
          onError={(e) => { e.target.src = PLACEHOLDER; }}
        />
      </div>
      <div className="pt-3">
        <p className="text-base text-gray-800">
          {name}{size_sqft ? ` - ${size_sqft.toLocaleString()} SQ FT` : ""}
        </p>
        {available_from && (
          <p className="text-sm text-gray-500 mt-1">
            Available from{" "}
            {new Date(available_from).toLocaleDateString("en-GB", {
              day: "numeric", month: "long", year: "numeric",
            })}
          </p>
        )}
      </div>
    </div>
  );
}